import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageSEO from '../components/PageSEO';
import { CheckCircle, ArrowRight, Clock, Bell, Activity } from 'lucide-react';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: 'transparent' }}>
      <PageSEO title="Ödeme Alındı" />
      <Header />
      <main className="max-w-lg mx-auto px-4 py-20 text-center">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{
          background: 'rgba(34,197,94,0.1)', border: '2px solid rgba(34,197,94,0.3)',
          boxShadow: '0 0 30px rgba(34,197,94,0.15)',
        }}>
          <CheckCircle className="w-10 h-10" style={{ color: '#34D399' }} />
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-testid="payment-success-title">
          Ödemeniz Alındı
        </h1>
        <p className="text-base leading-relaxed mb-8" style={{ color: 'rgba(255,255,255,0.5)' }}>
          Premium erişiminiz kısa süre içinde aktif edilecektir.
        </p>

        {/* Info cards */}
        <div className="space-y-3 mb-10 text-left">
          <div className="flex items-start gap-3 rounded-xl p-4" style={{ background: 'rgba(250,204,21,0.05)', border: '1px solid rgba(250,204,21,0.1)' }}>
            <Clock className="w-5 h-5 mt-0.5 shrink-0" style={{ color: '#FACC15' }} />
            <div>
              <p className="text-sm font-medium text-white">Genellikle 1–12 saat içinde aktif edilir</p>
              <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>Ödemeniz manuel olarak kontrol edilir ve onaylanır</p>
            </div>
          </div>

          <div className="flex items-start gap-3 rounded-xl p-4" style={{ background: 'rgba(34,211,238,0.05)', border: '1px solid rgba(34,211,238,0.1)' }}>
            <Bell className="w-5 h-5 mt-0.5 shrink-0" style={{ color: '#67E8F9' }} />
            <div>
              <p className="text-sm font-medium text-white">Aktif olduğunda bildirim alacaksınız</p>
              <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>Hesabınıza giriş yaptığınızda premium durumunuz görünecektir</p>
            </div>
          </div>

          <div className="flex items-start gap-3 rounded-xl p-4" style={{ background: 'rgba(139,92,246,0.05)', border: '1px solid rgba(139,92,246,0.1)' }}>
            <Activity className="w-5 h-5 mt-0.5 shrink-0" style={{ color: '#A78BFA' }} />
            <div>
              <p className="text-sm font-medium text-white">Bu sırada sisteminizi kullanmaya devam edebilirsiniz</p>
              <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)' }}>Check-in, görevler ve temel özellikler aktiftir</p>
            </div>
          </div>
        </div>

        <button onClick={() => navigate('/dashboard')}
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl text-sm font-bold text-white transition-all hover:scale-105"
          style={{ background: 'linear-gradient(135deg, #22D3EE, #0891B2)', boxShadow: '0 8px 25px rgba(34,211,238,0.3)' }}
          data-testid="payment-success-dashboard-btn">
          Dashboard'a Dön <ArrowRight className="w-4 h-4" />
        </button>
      </main>
      <Footer />
    </div>
  );
}
